<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="22.1973" width="30" height="2.80255" rx="1.40127" :stroke="color" stroke-width="2" />
    <path
      d="M25.4377 13.9944C25.4377 16.2309 23.8895 17.797 22.2638 17.797C20.638 17.797 19.0898 16.2309 19.0898 13.9944C19.0898 11.758 20.638 10.1919 22.2638 10.1919C23.8895 10.1919 25.4377 11.758 25.4377 13.9944Z"
      :stroke="color"
      stroke-width="2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5095 10.7943C9.1652 8.45682 8.9704 6.64054 7.28715 7.06071C6.15196 7.34407 5.08207 8.14605 7.28715 12.149C8.09966 13.6239 6.21293 14.9364 7.72694 16.7816C8.47929 17.6985 9.88396 18.1706 11.7578 18.1706C13.1673 18.1706 14.6533 18.3563 16.1333 17.7633C20.6891 15.9377 15.9359 8.9219 15.6974 8.28509C15.5567 7.90939 14.8281 6.896 13.7866 7.26277C12.8943 7.577 12.8943 8.73083 12.8943 8.73083C12.8943 8.73083 13.6588 10.7943 13.5284 10.7943H10.5095Z"
      :stroke="color"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'InfantIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
